import dico from "../../../util/src/language/dico";
import { TIMER_ACTIONS } from "../../../util/src/behavior-timers/protocol";
import type { BehaviorTemplateCatalogItem } from "./BehaviorTemplateCatalog";

export function timerCatalogItems(
  allowCommands: boolean,
): BehaviorTemplateCatalogItem[] {
  const b = dico().behavior;
  const result: BehaviorTemplateCatalogItem[] = [
    {
      id: "operator:readTimer",
      label: b.timers.read,
      section: "variables",
      categoryLabel: b.nodeList.categories.variables,
      subCategoryLabel: b.timers.title,
      dotColor: "#0f766e",
      isConnectableTarget: true,
      template: {
        type: "operator",
        mode: "unary",
        operator: "readTimer",
        inputValueTypes: ["string"],
        outputValueType: "number",
      },
    },
  ];
  if (allowCommands)
    for (const key of TIMER_ACTIONS)
      result.push({
        id: `action:set:${key}`,
        label: b.timers[key],
        section: "actions",
        categoryLabel: b.nodeList.categories.actions,
        subCategoryLabel: b.timers.title,
        dotColor: "#0f766e",
        isConnectableTarget: true,
        template: { type: "action", kind: "set", key },
      });
  return result;
}
